export const DASHBOARD_PATH = '/';
export const COURSE_RUN_DEMANDS_PATH = '/course-run-demands';
export const COURSE_RUN_DEMANDS_DETAIL_PATH = '/course-run-demands/:id';
export const MY_COURSE_RUN_DEMANDS_PATH = '/my-course-run-demands';
export const COURSE_LIST_PATH = '/courses';
export const CREATE_COURSE_PATH = '/courses/new';
export const UPDATE_COURSE_PATH = '/courses/:id';
export const ORG_COURSE_PATH = '/orgs/new';
export const ORG_SINGLE_PATH = '/orgs';
export const ORG_FORM_PATH = '/orgs/:id';
export const INSTRUCTOR_FORM_NEW_PATH = '/instructor/new';
export const INSTRUCTOR_FORM_EDIT_PATH = '/instructor/:id';
export const INSTRUCTOR_SINGLE_PATH = '/me';
